import { useQuery } from "@tanstack/react-query";

import { ReactQueryKeys } from "../services/ReactQueryKeys.ts";
import { useTemplateService } from "../services/useTemplateService.ts";

export function useTemplates(page: number, search?: string) {
  const { fetchTemplates } = useTemplateService();
  const queryKey = [ReactQueryKeys.TEMPLATES, page, search];

  const fetchTemplatesPage = async () => {
    return await fetchTemplates(page, search);
  };

  const {
    data,
    error: queryError,
    isError,
    isLoading
  } = useQuery({
    queryKey: queryKey,
    queryFn: fetchTemplatesPage
  });

  return {
    templates: data,
    isLoading,
    queryError,
    isError
  };
}
